import SignUpPage from '@/features/login/sign-up/page'
import { createFileRoute } from '@tanstack/react-router'

type SignUpSearchParams = {
  invitationId?: string
}

export const Route = createFileRoute('/login/sign-up')({
  component: SignUpPage,
  validateSearch: (search: Record<string, unknown>): SignUpSearchParams => ({
    invitationId: typeof search.invitationId === 'string' ? search.invitationId : undefined,
  }),
})
